<template>
	<BaseContenedor>
		<div class="ui four stackable cards">
			<router-link
				v-for="item in catalogos"
				:key="item.name"
				v-puede="item.roles"
				:to="`${primerNivel.url}${item.url}`"
				class=" card"
			>
				<div class="content grid">
					<sui-popup :content="item.description" inverted>
						<sui-icon
							slot="trigger"
							circular
							name="tiny info"
							:class="$style.topright"
						/>
					</sui-popup>
					<h3 class="image" style="font-size:80px;text-align: center">
						<img class="ui tiny image" :src="buildLogoUrl(item.icon)" />
					</h3>
				</div>
				<div class="extra content">
					<div class="header boldFont" :class="$style.titulo">{{
						item.title
					}}</div>
				</div>
			</router-link>
		</div>
	</BaseContenedor>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Menu from '@constants/menu';

export default {
	computed: {
		...mapGetters('oidc', ['oidcUser']),
		primerNivel: function() {
			return (
				Menu.filter(
					(item) => item.name === this.$router.currentRoute.name
				)[0] || {}
			);
		},
		catalogos: function() {
			return this.primerNivel.submenu || [];
		}
	},
	mounted() {
		this.establecerTitulo(this.primerNivel.title);
		this.establecerUrlAtras('/');
	},
	methods: {
		...mapActions('app', ['establecerTitulo', 'establecerUrlAtras']),
		buildLogoUrl(name) {
			return require('../../assets/images/' + name);
		}
	}
};
</script>

<style lang="scss" module>
.topright {
	position: absolute;
	top: 10px;
	right: 10px;
	font-size: 0.6em !important;
	color: #fff;
	background-color: #cacbcd;
}
.titulo {
	font-size: 18px;
	font-weight: bold;
	color: #5c5d5d;
}
</style>
